export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-marker-2cb6f8ef75c077d6557597e18b899753.svg";